import React from 'react';
// @ts-ignore
import DHTypography from "@digital-hig/mui/Typography";
import ErrorIcon from '../common/ErrorIcon';

interface ErrorMessageProps {
  show: boolean;
  message: string;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({ show, message }) => {
  if (!show) return null;

  return (
    <DHTypography 
      variant="body-copy-small"
      style={{
        color: '#d32f2f',
        fontSize: '12px',
        marginTop: '4px',
        marginLeft: '14px',
        fontWeight: '200',
        display: 'flex',
        alignItems: 'center',
        gap: '4px'
      }}
    >
      <ErrorIcon width={16} height={16} color="#d32f2f" />
      {message}
    </DHTypography>
  );
}; 